// src/components/ProtectedRoute/Admin/Consoles/Pages/TaxonomicActsConsole.jsx
import React from "react";
import ConsolePageFrame from "../Framework/ConsolePageFrame";
import taxonomicActsPlugin from "../Plugins/taxonomicActs.plugin";
import DialogTaxonomicActUpsert from "../../Dialogs/DialogTaxonomicActUpsert";

export default function TaxonomicActsConsole() {
  return (
    <ConsolePageFrame
      title="Taxonomic Acts"
      plugin={taxonomicActsPlugin}
      searchPlaceholder="Search by any field (id / names / page / remarks...)"
      columnsBuilder={({ onEdit }) => taxonomicActsPlugin.columns({ onEdit })}
      renderAddDialog={({ onClose }) => <DialogTaxonomicActUpsert open mode="add" onClose={onClose} />}
      renderEditDialog={({ row, onClose }) => (
        <DialogTaxonomicActUpsert open mode="edit" taxonomicAct={row} onClose={onClose} />
      )}
      toastMessages={{ create: "Taxonomic act created", update: "Taxonomic act updated" }}
    />
  );
}
